import { updateFieldState } from '@gef-ui/redux-common/actions/fieldState';
import { addFileInput, removeFileInput } from '@gef-ui/redux-common/actions/fileInputs';
import { updateFormState } from '@gef-ui/redux-common/actions/formState';
import { clearGlobalErrors } from '@gef-ui/redux-common/actions/globalErrors';
import { getFieldFromDescriptor } from '@gef-ui/redux-common/selectors/fieldDescriptor';
import { getFormData, getFormDataValue } from '@gef-ui/redux-common/selectors/formData';
import { getFieldErrorMessages, getFieldErrorMeta } from '@gef-ui/redux-common/selectors/globalErrors';
import { getRegisteredField } from '@gef-ui/redux-common/selectors/registeredFields';
import { validateDirtyFieldsAsync, validateField } from '@gef-ui/validations/actions/validate';
import invariant from 'invariant';
import compose from "ramda/es/compose";
import defaultTo from "ramda/es/defaultTo";
import prop from "ramda/es/prop";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { defaultFieldValue, updateFieldValue } from '../../../actions/form';
import { registerField, unregisterField } from '../../../actions/registeredField';
import { defaultFieldState } from '../../../constants';
import withForm from '../../../decorators/withForm';
import withSection from '../../../decorators/withSection';
const stateP = prop('state');
const defaultState = (ownProps)=>defaultTo({
        state: defaultFieldState(ownProps)
    });
const getRequiredWhenParams = ({ formName, state, fieldDescriptor, fieldValue })=>({
        fieldValue,
        formName,
        formData: getFormData(formName)(state),
        fieldDescriptor,
        state
    });
export const mapStateToProps = (state, ownProps)=>{
    const { formName, fieldName, temp, label } = ownProps;
    invariant(formName, `formName for field ${fieldName} must be present.
	You are probably trying to register field outside of the form`);
    let deepPath;
    let descriptor;
    let fieldDescriptor;
    try {
        fieldDescriptor = getFieldFromDescriptor(formName)(state)(fieldName);
        deepPath = fieldDescriptor.deepPath;
        descriptor = fieldDescriptor.descriptor;
    } catch (_e) {
        invariant(deepPath, `Can not find deepPath for descriptor with fieldName: ${fieldName}.`);
    }
    const fieldState = compose(stateP, defaultState(ownProps), getRegisteredField(formName)(state))(fieldName);
    const { valid, pristine, asyncValidationInProgress } = fieldState;
    const required = descriptor.required;
    const fieldValue = getFormDataValue(formName)(state)({
        deepPath,
        temp
    });
    return {
        value: fieldValue,
        label: label ? label : descriptor.name,
        required: typeof required === 'function' ? required(getRequiredWhenParams({
            formName,
            state,
            fieldDescriptor,
            fieldValue
        })) : required,
        deepPath,
        pristine,
        valid,
        asyncValidationInProgress,
        errMessage: getFieldErrorMessages(formName)(state)(fieldName),
        errMeta: getFieldErrorMeta(formName)(state)(fieldName)
    };
};
export const mapDispatchToProps = (dispatch, { formName })=>({
        ...bindActionCreators({
            validate: validateField(formName),
            validateAsync: validateDirtyFieldsAsync(formName),
            updateFieldValue: updateFieldValue(formName),
            defaultFieldValue: defaultFieldValue(formName),
            updateFieldState: updateFieldState(formName),
            updateFormState: updateFormState(formName),
            register: registerField(formName),
            addFileInput: addFileInput(formName),
            removeFileInput: removeFileInput(formName),
            unregister: unregisterField(formName),
            clearGlobalErrors: clearGlobalErrors(formName)
        }, dispatch)
    });
export default compose(withForm, withSection, connect(mapStateToProps, mapDispatchToProps));
